module.exports = __webpack_public_path__ + "img/数据查看权限.783f0fae.svg";